import { defineMessages } from 'react-intl';

const _default_1: {
	readonly voiceDictationButtonLabel: {
		readonly id: 'rovo-chat.voice-dictation.label';
		readonly defaultMessage: 'Dictation';
		readonly description: 'Label for the voice dictation button in the chat input';
	};
} = defineMessages({
	voiceDictationButtonLabel: {
		id: 'rovo-chat.voice-dictation.label',
		defaultMessage: 'Dictation',
		description: 'Label for the voice dictation button in the chat input',
	},
} as const);
export default _default_1;
